import axiosClass from '@/../util/axiosClass';

/**
 * TODO 관련 API 서비스 클래스
 */
class TodoService {
    constructor() {
        this.cache = new Map();
        this.cacheTimeout = 5 * 60 * 1000; // 5분 캐시
        this.metadataCache = new Map();
        this.metadataCacheTimeout = 30 * 60 * 1000; // 30분 캐시
        
        // 중복 요청 방지를 위한 진행중인 요청 추적
        this.pendingRequests = new Map();
    }

    /**
     * 캐시 키 생성
     */
    generateCacheKey(method, params) {
        return `${method}_${JSON.stringify(params)}`;
    }

    /**
     * 캐시에서 데이터 조회
     */
    getFromCache(key) {
        const cached = this.cache.get(key);
        if (cached && Date.now() - cached.timestamp < this.cacheTimeout) {
            return cached.data;
        }
        this.cache.delete(key);
        return null;
    }

    /**
     * 캐시에 데이터 저장
     */
    setCache(key, data) {
        this.cache.set(key, {
            data,
            timestamp: Date.now()
        });
    }

    /**
     * 메타데이터 캐시 조회
     */
    getMetadataFromCache(key) {
        const cached = this.metadataCache.get(key);
        if (cached && Date.now() - cached.timestamp < this.metadataCacheTimeout) {
            return cached.data;
        }
        this.metadataCache.delete(key);
        return null;
    }

    /**
     * 메타데이터 캐시 저장
     */
    setMetadataCache(key, data) {
        this.metadataCache.set(key, {
            data,
            timestamp: Date.now()
        });
    }

    /**
     * TODO 리스트 조회 (캐싱 적용)
     */
    async getTodoList(params) {
        console.log('todoService.getTodoList 호출됨:', params);
        console.log('🔍 성능 모니터링: API 호출 시작 시간:', new Date().toISOString());
        
        const cacheKey = this.generateCacheKey('todoList', params);
        console.log('캐시 키:', cacheKey);
        
        // 캐시 확인 (임시로 비활성화)
        // const cachedData = this.getFromCache(cacheKey);
        // if (cachedData) {
        //     console.log('캐시에서 데이터 반환:', cachedData);
        //     return cachedData;
        // }
        
        // 중복 요청 방지 - 동일한 요청이 진행중인지 확인
        if (this.pendingRequests.has(cacheKey)) {
            console.log('🔄 동일한 요청이 진행중입니다. 기다리는 중...');
            return await this.pendingRequests.get(cacheKey);
        }

        // 요청 Promise 생성 및 저장
        const requestPromise = this.makeApiRequest(params);
        this.pendingRequests.set(cacheKey, requestPromise);
        
        try {
            const result = await requestPromise;
            return result;
        } finally {
            // 요청 완료 후 진행중인 요청에서 제거
            this.pendingRequests.delete(cacheKey);
        }
    }
    
    /**
     * 실제 API 요청 수행
     */
    async makeApiRequest(params) {
        try {
            // 탭별 선택적 데이터 로딩을 위한 tab 파라미터 추가
            let tabParam = 'all';
            switch(params.tab) {
                case 1: // 리콜Todo
                case 2: // 신규
                case 3: // 신규(재)
                case 6: // Black
                    tabParam = 'todo';
                    break;
                case 4: // 이슈Todo
                    tabParam = 'issue';
                    break;
                case 5: // VIP
                    tabParam = 'vip';
                    break;
                default:
                    tabParam = 'all';
            }
            
            const apiUrl = '/api/cs/todo/' + params.date;
            const queryParams = {
                _t: Date.now(),
                counselor: params.counselor,
                tab: tabParam,
                tabNumber: params.tab, // 실제 탭 번호 (1:리콜, 2:신규, 3:신규재)
                page: params.page || 1,
                pageSize: params.pageSize || 50
            };
            
            console.log('🔄 실제 API 호출 시도:', apiUrl, '탭:', tabParam);
            console.log('🔄 전체 쿼리 파라미터:', queryParams);
            console.log('🔄 백엔드 서버 상태 확인 중...');
            
            const startTime = Date.now();
            const { data } = await axiosClass.get(apiUrl, queryParams, true);
            const endTime = Date.now();
            const responseTime = endTime - startTime;
            
            console.log('✅ 백엔드 응답 성공! 응답시간:', responseTime + 'ms');
            console.log('📊 응답 데이터 분석:');
            console.log('  - 응답 크기 (대략):', JSON.stringify(data).length / (1024 * 1024), 'MB');
            console.log('  - 데이터 키 개수:', Object.keys(data).length);
            
            if (data.todoAllData) {
                console.log('  - todoAllData 배열 크기:', data.todoAllData.length, '개');
                console.log('  - 개별 항목 크기 (첫 번째):', JSON.stringify(data.todoAllData[0] || {}).length, 'bytes');
            }
            
            // 새로운 응답 데이터 구조 처리 (백엔드에서 탭별 데이터 전송)
            console.log('data 타입:', typeof data);
            console.log('data 키들:', Object.keys(data));
            
            let todoList = [];
            
            // 탭에 따라 적절한 데이터 선택 (백엔드에서 이미 필터링됨)
            if (tabParam === 'todo' && data.todoData && Array.isArray(data.todoData)) {
                todoList = data.todoData;
            } else if (tabParam === 'vip' && data.vipListData && Array.isArray(data.vipListData)) {
                todoList = data.vipListData;
            } else if (tabParam === 'issue' && data.issueTodoList && Array.isArray(data.issueTodoList)) {
                todoList = data.issueTodoList;
            } else if (tabParam === 'count' && data.todoCountData && Array.isArray(data.todoCountData)) {
                todoList = data.todoCountData;
            } else if (tabParam === 'all') {
                // 모든 데이터가 필요한 경우 (기존 호환성)
                if (data.todoAllData && Array.isArray(data.todoAllData)) {
                    todoList = data.todoAllData;
                } else if (data.todoData && Array.isArray(data.todoData)) {
                    todoList = data.todoData;
                } else if (Array.isArray(data)) {
                    todoList = data;
                } else if (data.data && Array.isArray(data.data)) {
                    todoList = data.data;
                }
            }
            
            console.log('선택된 데이터:', tabParam, '배열 크기:', todoList.length);
            
            // 백엔드에서 이미 페이지네이션이 처리된 데이터를 사용
            let finalList = todoList;
            let paginationInfo = null;
            
            if (params.counselor === 'none') {
                finalList = [];
                console.log('담당자 선택 안함 - 빈 배열 반환');
            } else {
                // 백엔드에서 이미 페이지네이션과 필터링이 처리되었으므로 그대로 사용
                finalList = todoList;
                console.log('백엔드 최적화 데이터 사용:', finalList.length, '개');
                
                // 백엔드에서 페이지네이션 정보도 받았는지 확인
                if (data.pagination) {
                    paginationInfo = data.pagination;
                    console.log('백엔드에서 페이지네이션 정보 받음:', paginationInfo);
                }
            }
            
            // 페이지네이션 정보가 없으면 클라이언트에서 생성 (fallback)
            if (!paginationInfo) {
                const pageSize = params.pageSize || 50;
                const currentPage = params.page || 1;
                
                // VIP 탭만 클라이언트 사이드 페이징 적용 (이슈는 백엔드 페이징)
                if (tabParam === 'vip') {
                    const totalCount = finalList.length;
                    const vipPageSize = 100; // VIP는 100개씩 고정
                    const startIndex = (currentPage - 1) * vipPageSize;
                    const endIndex = startIndex + vipPageSize;
                    
                    // 현재 페이지에 해당하는 데이터만 추출
                    finalList = finalList.slice(startIndex, endIndex);
                    
                    paginationInfo = {
                        currentPage: currentPage,
                        pageSize: vipPageSize,
                        totalCount: totalCount,
                        totalPages: Math.ceil(totalCount / vipPageSize)
                    };
                    
                    console.log('VIP 탭 클라이언트 사이드 페이징 적용 (100개 고정):', {
                        totalCount,
                        currentPage,
                        pageSize: vipPageSize,
                        startIndex,
                        endIndex,
                        slicedDataCount: finalList.length
                    });
                } else {
                    // 기존 로직
                    paginationInfo = {
                        currentPage: currentPage,
                        pageSize: pageSize,
                        totalCount: finalList.length,
                        totalPages: Math.ceil(finalList.length / pageSize)
                    };
                }
                console.log('클라이언트에서 페이지네이션 정보 생성:', paginationInfo);
            }
            
            const formattedResponse = {
                success: true,
                list: finalList,
                pagination: paginationInfo
            };
            
            console.log('포맷된 응답:', formattedResponse);
            
            // 캐시에 저장 (임시로 비활성화)
            // this.setCache(cacheKey, formattedResponse);
            
            return formattedResponse;
        } catch (error) {
            console.error('❌ API 호출 실패:', error);
            console.error('❌ 백엔드 서버가 꺼져있거나 네트워크 오류 발생');
            console.error('❌ Error details:', {
                message: error.message,
                status: error.response && error.response.status,
                statusText: error.response && error.response.statusText
            });
            throw error;
        }
    }

    /**
     * 날짜 범위 조회 (기존 API가 없으므로 더미 데이터 반환)
     */
    async getDateRange(date) {
        const cacheKey = this.generateCacheKey('dateRange', { date });
        
        // 캐시 확인
        const cachedData = this.getFromCache(cacheKey);
        if (cachedData) {
            return cachedData;
        }

        try {
            // 더미 날짜 범위 데이터 반환
            const startDate = new Date(
                parseInt(date.substr(0, 4)),
                parseInt(date.substr(4, 2)) - 1,
                parseInt(date.substr(6, 2))
            );
            
            const endDate = new Date(startDate);
            endDate.setDate(endDate.getDate() + 6);
            
            const formattedResponse = {
                success: true,
                startDate: this.formatDate(startDate),
                endDate: this.formatDate(endDate),
                displayRange: `${this.formatDateForDisplay(startDate)} ~ ${this.formatDateForDisplay(endDate)}`
            };
            
            // 날짜 범위는 더 오래 캐시 (1시간)
            this.cache.set(cacheKey, {
                data: formattedResponse,
                timestamp: Date.now()
            });
            
            return formattedResponse;
        } catch (error) {
            console.error('날짜 범위 조회 오류:', error);
            throw error;
        }
    }

    /**
     * 메타데이터 조회 (더미 데이터 반환)
     */
    async getMetadata(userUid) {
        const cacheKey = `metadata_${userUid}`;
        
        // 캐시 확인
        const cachedData = this.getMetadataFromCache(cacheKey);
        if (cachedData) {
            return cachedData;
        }

        try {
            // 더미 메타데이터 반환
            const formattedResponse = {
                success: true,
                data: {
                    users: [],
                    codes: []
                }
            };
            
            // 메타데이터 캐시에 저장
            this.setMetadataCache(cacheKey, formattedResponse);
            
            return formattedResponse;
        } catch (error) {
            console.error('메타데이터 조회 오류:', error);
            throw error;
        }
    }

    /**
     * 캐시 무효화
     */
    clearCache(type = 'all') {
        switch (type) {
            case 'todo':
                this.cache.clear();
                break;
            case 'metadata':
                this.metadataCache.clear();
                break;
            case 'all':
            default:
                this.cache.clear();
                this.metadataCache.clear();
                break;
        }
    }

    /**
     * 특정 패턴의 캐시 무효화
     */
    clearCacheByPattern(pattern) {
        for (const key of this.cache.keys()) {
            if (key.includes(pattern)) {
                this.cache.delete(key);
            }
        }
    }

    /**
     * 캐시 상태 조회
     */
    getCacheStats() {
        return {
            todoCache: {
                size: this.cache.size,
                keys: Array.from(this.cache.keys())
            },
            metadataCache: {
                size: this.metadataCache.size,
                keys: Array.from(this.metadataCache.keys())
            }
        };
    }

    /**
     * 배치 요청 처리 (여러 요청을 한번에)
     */
    async batchRequest(requests) {
        const promises = requests.map(request => {
            switch (request.type) {
                case 'todoList':
                    return this.getTodoList(request.params);
                case 'dateRange':
                    return this.getDateRange(request.params.date);
                case 'metadata':
                    return this.getMetadata(request.params.userUid);
                default:
                    return Promise.reject(new Error(`Unknown request type: ${request.type}`));
            }
        });

        try {
            const results = await Promise.allSettled(promises);
            return results.map((result, index) => ({
                type: requests[index].type,
                success: result.status === 'fulfilled',
                data: result.status === 'fulfilled' ? result.value : null,
                error: result.status === 'rejected' ? result.reason : null
            }));
        } catch (error) {
            console.error('배치 요청 처리 오류:', error);
            throw error;
        }
    }

    /**
     * 프리로딩 (미리 데이터 로드)
     */
    async preloadData(params) {
        const preloadRequests = [
            { type: 'dateRange', params: { date: params.date } }
        ];

        // 다음/이전 날짜도 미리 로드
        if (params.preloadAdjacent) {
            const prevDate = this.getPrevWeekDate(params.date);
            const nextDate = this.getNextWeekDate(params.date);
            
            preloadRequests.push(
                { type: 'dateRange', params: { date: prevDate } },
                { type: 'dateRange', params: { date: nextDate } }
            );
        }

        // 백그라운드에서 프리로드 (오류는 무시)
        this.batchRequest(preloadRequests).catch(error => {
            console.log('프리로드 중 일부 실패:', error);
        });
    }

    /**
     * 이전 주 날짜 계산
     */
    getPrevWeekDate(dateStr) {
        const date = new Date(
            parseInt(dateStr.substr(0, 4)),
            parseInt(dateStr.substr(4, 2)) - 1,
            parseInt(dateStr.substr(6, 2))
        );
        date.setDate(date.getDate() - 7);
        
        return date.getFullYear().toString() + 
               (date.getMonth() + 1).toString().padStart(2, '0') + 
               date.getDate().toString().padStart(2, '0');
    }

    /**
     * 다음 주 날짜 계산
     */
    getNextWeekDate(dateStr) {
        const date = new Date(
            parseInt(dateStr.substr(0, 4)),
            parseInt(dateStr.substr(4, 2)) - 1,
            parseInt(dateStr.substr(6, 2))
        );
        date.setDate(date.getDate() + 7);
        
        return date.getFullYear().toString() + 
               (date.getMonth() + 1).toString().padStart(2, '0') + 
               date.getDate().toString().padStart(2, '0');
    }

    /**
     * 날짜를 YYYYMMDD 형식으로 포맷
     */
    formatDate(date) {
        return date.getFullYear().toString() + 
               (date.getMonth() + 1).toString().padStart(2, '0') + 
               date.getDate().toString().padStart(2, '0');
    }

    /**
     * 날짜를 표시용 포맷으로 변환 (MM/DD)
     */
    formatDateForDisplay(date) {
        return `${date.getMonth() + 1}/${date.getDate()}`;
    }

    /**
     * 탭에 따른 데이터 필터링
     */
    filterByTab(todoList, tabType) {
        if (!Array.isArray(todoList)) return [];
        
        switch (tabType) {
            case 1: // 리콜Todo
                return todoList.filter(item => {
                    // 리콜 예정일이 있는 항목들
                    return item.NEXT_DATE && item.NEXT_DATE !== '' && item.NEXT_DATE !== 'null';
                });
                
            case 2: // 신규
                return todoList.filter(item => {
                    // 신규 항목 필터링 로직 (기존 Todo.vue 참고)
                    return item.CS_CATE_CODE === 'NEW' || (!item.NEXT_DATE || item.NEXT_DATE === '' || item.NEXT_DATE === 'null');
                });
                
            case 3: // 신규(재)
                return todoList.filter(item => {
                    // 신규 재방문 항목
                    return item.CS_CATE_CODE === 'RENEW';
                });
                
            case 4: // 이슈Todo
                return todoList.filter(item => {
                    // 이슈 항목
                    return item.CS_CATE_CODE === 'ISSUE';
                });
                
            case 5: // VIP
                return todoList.filter(item => {
                    // VIP 항목
                    return item.CS_FAVOR_CODE === 'VIP' || item.PATIENT_GRADE === 'VIP';
                });
                
            case 6: // Black
                return todoList.filter(item => {
                    // Black 항목
                    return item.CS_FAVOR_CODE === 'BLACK' || item.PATIENT_GRADE === 'BLACK';
                });
                
            default:
                return todoList;
        }
    }

    /**
     * 상담 담당자 목록 추출
     */
    getCounselorList(todoList) {
        if (!Array.isArray(todoList)) return [];
        
        const counselors = new Set();
        todoList.forEach(item => {
            if (item.MAIN_CS_USERNAME && item.MAIN_CS_USERNAME.trim() !== '') {
                counselors.add(item.MAIN_CS_USERNAME);
            }
        });
        
        return Array.from(counselors).sort();
    }
}

// 싱글톤 인스턴스 생성
const todoService = new TodoService();

export default todoService;